import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    ADD_ADMIN_PROXIES_SUCCESS,
    ADD_ADMIN_PROXIES_FAILURE,
    UPDATE_ADMIN_PROXY_SUCCESS,
    UPDATE_ADMIN_PROXY_FAILURE,
    GET_ADMIN_PROXY_LIST_SUCCESS,
    GET_ADMIN_PROXY_LIST_FAILURE,
    GET_ADMIN_PROXY_USER_LIST_SUCCESS,
    GET_ADMIN_PROXY_USER_LIST_FAILURE,
} from 'src/pages/admin/redux/action/actionTypes.js';

import {
    addProxiesService,
    updateProxiesService,
    getProxyListService,
    getAdminProxyUserListService,
} from 'src/pages/admin/redux/services/index.js';

export function* addProxies(action) {
    try {
        const result = yield addProxiesService(action.payload);
        yield put({ type: ADD_ADMIN_PROXIES_SUCCESS, payload: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/addproxy`,
            requestPayload: action.payload
        });
        yield put({
            type: ADD_ADMIN_PROXIES_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* updateProxy(action) {
    try {
        const result = yield updateProxiesService(action.payload);
        yield put({ type: UPDATE_ADMIN_PROXY_SUCCESS, payload: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/updateProxy`,
            requestPayload: action.payload
        });
        yield put({
            type: UPDATE_ADMIN_PROXY_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* getProxyList(action) {
    try {
        const result = yield getProxyListService(action.payload);

        yield put({ type: GET_ADMIN_PROXY_LIST_SUCCESS, proxyList: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `/occ/v2/${localStorage.getItem('baseSiteId')}/proxy/proxies`,
            requestPayload: action.payload
        });
        yield put({
            type: GET_ADMIN_PROXY_LIST_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
export function* getAdminProxyUserList(action) {
    try {
        const result = yield getAdminProxyUserListService(action.payload);
        yield put({
            type: GET_ADMIN_PROXY_USER_LIST_SUCCESS,
            proxyUserList: result,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/getProxyUsers`,
            requestPayload: action.payload
        });
        yield put({
            type: GET_ADMIN_PROXY_USER_LIST_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
